/**
 * @desc 待补录信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDlrRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/dlrTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
